import { useContext } from "react";
import { Route } from "react-router-dom";
import UserContext from "./context/UserContext";

export default function PrivateRoute({ component: Component, ...rest }) {
  const { userData } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        userData?.token && userData?.user ? (
          <Component {...props} {...rest} />
        ) : (
          (window.location.href = process.env.REACT_APP_APPLICATION_URL)
        )
      }
    />
  );
}
